(ns ycweb.app.blitz.aftersales.receiving
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.blitz.receiving.receiving :as receiving]
   [ycweb.app.pos.menu :as menu]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.header :as header]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]))

(def steps
  (forms/setup-steps
    [{:key :printer :title "Scan Printer"}
     {:key :search :title "Scan Item or Search"}
     {:key :returncases :title "Return Cases"}
     {:key :returncaseitems :title "Return Case Items"}
     {:key :returncaseitem-edit :title "Item Details"}
     {:key :location :title "Scan Location"}
     {:key :items :title "Scan Items"}
     {:key :confirm :title "Confirm"}
     {:key :finished :title "Done"}]))

(rum/defc screen-wrapper [app-atom {:keys [modal-fn]} progress-step body foot-note call-to-action]
  [:div.page-body
   (header/header app-atom "Aftersales Receiving" {})
   (header/menu-overlay (rum/cursor app-atom :menu))
   (header/menu app-atom (menu/select-menus app-atom))
   (into
     [:div.page-body__main-content
      (when modal-fn
        [:nav.section.button-bar
         (buttons/button
           " Options"
           #(modal-fn app-atom)
           {:icon-right :dots-menu-horizontal :muted true :text-default true})])
      [:div.section
       (forms/progress-steps
         (forms/progress-step steps progress-step))]]
     body)
   (into
     [:aside.page-body__footer]
     foot-note)
   call-to-action])


(defmethod flow/barcode-dispatch-screen :aftersalesreceiving/printer [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersalesreceiving/printer-scan {:scan scan}))

(defmethod grid/action :aftersalesreceiving/printer-scan [app-atom {:keys [scan]} _]
  (t/transition-next app-atom :aftersalesreceiving/search)
  (swap! app-atom assoc-in [:aftersalesreceiving :printer] scan))

(defmethod grid/action :aftersalesreceiving/printer-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :aftersalesreceiving/printer-scan
     :input-key :scan
     :input-type :barcode}))

(defn printer-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :aftersalesreceiving/printer-menu-barcode}

      {:label "Cancel"
       :action :aftersalesreceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc printer < rum/reactive [app-atom]
  (screen-wrapper app-atom {:modal-fn printer-modal} :printer
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Printer"]
      [:div
       [:i.u-block-center
        {:class
         (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]]
    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush])}
       "Scan the printer you'll be using"]]]
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-plain true})))

(defmethod flow/render-screen :aftersalesreceiving/printer [app-atom screen]
  (swap! app-atom assoc :aftersalesreceiving nil)
  (printer app-atom))

(rum/defc search < rum/reactive [app-atom]
  (let [search-atom (rum/cursor-in app-atom [:aftersalesreceiving :search])]
    (screen-wrapper app-atom {} :search
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Item or Enter Search Term"]
        (forms/input "YCR, YC, Waybill, Reference:" "e.g. YCR86112" search-atom
          {:type :barcode :required? true})]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when-not (str/blank? (rum/react search-atom))
           #(grid/dispatch-action app-atom
              :aftersalesreceiving/search {}))}))))

(defmethod flow/render-screen :aftersalesreceiving/search [app-atom screen]
  (search app-atom))

(defmethod flow/barcode-dispatch-screen :aftersalesreceiving/search [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersalesreceiving/search {:scan scan}))

(defmethod grid/action :aftersalesreceiving/search [app-atom {:keys [scan]} _]
  (toaster/open-toast app-atom :processing "Loading return case" {})
  (let [search (get-in @app-atom [:aftersalesreceiving :search])]
    (comms/send :aftersalesreceiving/search {:input search :scan scan})))

(defmethod comms/receive :aftersalesreceiving/search [app-atom e]
  (toaster/close-toast app-atom)
  (t/transition-next app-atom :aftersalesreceiving/returncases)
  (swap! app-atom assoc-in [:aftersalesreceiving :returncases] (:returncases e)))


(rum/defc returncaseitem-slat < rum/reactive
  [{:keys [expected resolved usagetype destination barcode vbarcode product reasoncode reasontext status] itemtype :type} {:keys [on-click]}]
  [:article.slat.return-order-slat
   {:on-click (when on-click on-click)}
   [:h1.return-order-slat__title
    [:b product]]
   [:ul.return-order-slat__detail-list
    [:li.return-order-slat__detail-item
     [:b "Type: "] (str itemtype)]
    [:li.return-order-slat__detail-item
     [:b "Expected: "] (str (if expected "Yes" "No"))]
    [:li.return-order-slat__detail-item
     [:b "Reason: "] reasoncode]
    [:li.return-order-slat__detail-item
     [:b "Customer Note: "] (str reasontext)]]
   [:div.return-order-slat__status-wrapper
    [:span.return-order-slat__status
     [(if (u/presence barcode) :span.u-text-status-success :span.u-text-status-warning)
      [:b
       (or
         (u/presence barcode)
         (when vbarcode (str "Not Assigned (" vbarcode ")"))
         "Not Assigned")]]]
    [:span.return-order-slat__status
     [(case destination
        "Blank"
        :span.u-text-status-warning
        :span.u-text-status-success) [:b destination]]]]])

(rum/defc returncaseitems < rum/reactive
  [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesreceiving])
        items (cmn/curact current-atom :returncaseitems)
        allow-next?
        (empty?
          (remove
            #(and
               (u/presence (:barcode %))
               (not= (:destination %) "Blank"))
            items))]

    (screen-wrapper app-atom {} :returncaseitems
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Return Case Items"]]
       (map
         (fn [i]
           (rum/with-key
             (returncaseitem-slat
               i
               {:on-click
                #(grid/dispatch-action app-atom :aftersalesreceiving/returncaseitem-edit {:returncaseitem i})})
             (:id i)))
         items)]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when
           allow-next?
           #(t/transition-next app-atom :aftersalesreceiving/location))}))))

(defmethod flow/render-screen :aftersalesreceiving/returncaseitems [app-atom screen]
  (returncaseitems app-atom))


(rum/defc order-slat < rum/reactive
  [{:keys [contactname dateinvoiced collectionref waybillnumber status refid orefid dateadded itemqty]} {:keys [on-click]}]
  [:article.slat.return-order-slat
   {:on-click (when on-click on-click)}
   [:h1.return-order-slat__title
    [:span.return-order-slat__order-no (str "YCR" refid " (YC" orefid ")")]]
   [:ul.return-order-slat__detail-list
    [:li.return-order-slat__detail-item
     [:b
      contactname]]
    [:li.return-order-slat__detail-item
     [:b "Date: "]
     (str
       (ud/format-date dateadded "EEE, dd MMM yyyy")
       (when (u/presence collectionref) " Ref: ") collectionref
       (when (u/presence waybillnumber) " Waybill: ") waybillnumber)]
    [:li.return-order-slat__detail-item
     [:b "Invoice Date: "]
     (str
       (ud/format-date dateinvoiced "EEE, dd MMM yyyy"))]]
   [:div.return-order-slat__status-wrapper
    [:span.return-order-slat__status (str itemqty " Items")]
    [:span.return-order-slat__status
     [(case status
        "Ready"
        :span.u-text-status-success
        :span.u-text-status-warning) [:b status]]]]])

(rum/defc returncases < rum/reactive
  [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesreceiving])]
    (screen-wrapper app-atom {} :returncases
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Return Cases"]]
       (map
         (fn [r]
           (rum/with-key
             (order-slat
               r
               {:on-click
                #(grid/dispatch-action app-atom :aftersalesreceiving/select-returncase {:returncase r})})
             (:id r)))
         (cmn/curact current-atom :returncases))]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))


(defmethod flow/render-screen :aftersalesreceiving/returncases [app-atom screen]
  (returncases app-atom))


(defmethod grid/action :aftersalesreceiving/select-returncase [app-atom {:keys [returncase]}]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom assoc-in [:aftersalesreceiving :returncase] returncase)
  (comms/send :aftersalesreceiving/session-start {:returncase-id (:id returncase)}))


(defmethod comms/receive :aftersalesreceiving/session-start
  [app-atom {:keys [returncaseitems reason->destination allow-reason-change? item-resolutions delivery-uuid session-id]}]
  (toaster/close-toast app-atom)
  (swap! app-atom update :aftersalesreceiving assoc
    :returncaseitems returncaseitems
    :reason->destination reason->destination
    :allow-reason-change? allow-reason-change?
    :item-resolutions item-resolutions
    :delivery-uuid delivery-uuid
    :session-id session-id)
  (t/transition-next app-atom :aftersalesreceiving/returncaseitems))


(defmethod grid/action :aftersalesreceiving/location-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :aftersalesreceiving/location-scan
     :input-key :scan
     :input-type :barcode}))

(defn location-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :aftersalesreceiving/location-menu-barcode}

      {:label "Cancel"
       :action :aftersalesreceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc location < rum/reactive [app-atom]
  (screen-wrapper app-atom {:modal-fn location-modal} :location
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Location"]
      [:div
       [:i.u-block-center
        {:class
         (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]]
    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush])}
       "Scan the location you're receiving to"]]]
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom :aftersalesreceiving/returncaseitems)
       :right-plain true})))

(defmethod flow/render-screen :aftersalesreceiving/location [app-atom screen]
  (location app-atom))

(defmethod flow/barcode-dispatch-screen :aftersalesreceiving/location [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersalesreceiving/location-scan {:scan scan}))

(defmethod grid/action :aftersalesreceiving/location-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/location-scan
    {:scan scan
     :session-id (get-in @app-atom [:aftersalesreceiving :session-id])}))

(defmethod comms/receive :aftersalesreceiving/location-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (cond
    (not (:location e))
    (toaster/open-toast app-atom :error "No location found" {})

    :else
    (do
      (t/transition-next app-atom :aftersalesreceiving/items)
      (swap! app-atom update :aftersalesreceiving assoc
        :location (:location e)
        :allow-close? (:allow-close? e)
        :items (:items e)))))

(defmethod grid/action :aftersalesreceiving/order [app-atom config _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/order
    {:session-id (get-in @app-atom [:aftersalesreceiving :session-id])}))

(defmethod comms/receive :aftersalesreceiving/order [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (grid/dispatch-action app-atom :aftersalesreceiving/confirm {}))

(rum/defc returncaseitem-edit < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesreceiving])
        returncase (cmn/curact current-atom :returncase)
        allow-reason-change? (cmn/curact current-atom :allow-reason-change?)
        item-atom (rum/cursor-in current-atom [:returncaseitem])
        destination (cmn/curact item-atom :destination)
        resolution (cmn/curact item-atom :resolution)
        rejectreason (cmn/curact item-atom :rejectreason)
        reasoncode (cmn/curact item-atom :reasoncode)
        product (cmn/curact item-atom :product)
        item-resolutions (cmn/curact current-atom :item-resolutions)
        reason->destination (cmn/curact current-atom :reason->destination)
        item-reasoncodes (keys reason->destination)
        item-destinations (get reason->destination reasoncode)]

    (screen-wrapper app-atom {} :returncaseitem-edit
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Set Item Details"
         [:span.heading__subtext product]]
        
        [:p.paragraph
         "Customer is requesting: "
         [:b (:refundtype returncase)]]
        
        (forms/select
          "Reason for item return:"
          (rum/cursor item-atom :reasoncode)
          (map
            (fn [d]
              {:value d :text d})
            item-reasoncodes)
          {:default reasoncode :disabled (not allow-reason-change?)})
        
        (forms/select
          "Resolution for item:"
          (rum/cursor item-atom :resolution)
          (map
            (fn [d]
              {:value d :text d})
            (concat ["Blank"] item-resolutions))
          {:default resolution})

        (when (= resolution "Reject") 
          (forms/textarea "Reject Reason:"
            (rum/cursor item-atom :rejectreason)))
        
        (forms/select
          "Destination for item:"
          (rum/cursor item-atom :destination)
          (map
            (fn [d]
              {:value d :text d})
            (concat ["Blank"] item-destinations))
          {:default destination})

        [:div.form-field
         [:label.form-label
          "Expected:"]
         (forms/radio [:b "Yes"]
           true (rum/cursor item-atom :expected))]

        [:div.form-field
         (forms/radio [:b "No"]
           false (rum/cursor item-atom :expected))]]]

      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Update"
         :right-fn
         (cond
           (= destination "Blank")
           nil

           (= resolution "Blank")
           nil

           (and (= destination "Reject") (nil? (u/presence rejectreason)))
           nil

           :else
           #(grid/dispatch-action app-atom :aftersalesreceiving/returncaseitem-update {}))}))))


#_(defmethod flow/barcode-dispatch-screen :aftersalesreceiving/returncaseitem-edit [_ app-atom scan]
    (if (= (:destination (get-in @app-atom [:aftersalesreceiving :returncaseitem])) "Blank")
      (toaster/open-toast app-atom :warning "Select destination before scanning" {})
      (grid/dispatch-action app-atom :aftersalesreceiving/returncaseitem-update {:scan scan})))


(defmethod flow/render-screen :aftersalesreceiving/returncaseitem-edit [app-atom screen]
  (returncaseitem-edit app-atom))

(defmethod grid/action :aftersalesreceiving/returncaseitem-edit [app-atom {:keys [returncaseitem]}]
  (swap! app-atom assoc-in [:aftersalesreceiving :returncaseitem] returncaseitem)
  (t/transition-next app-atom :aftersalesreceiving/returncaseitem-edit))


(defmethod grid/action :aftersalesreceiving/returncaseitem-update [app-atom config _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/returncaseitem-update
    {:printer (get-in @app-atom [:aftersalesreceiving :printer])
     :returncaseitem-updates (get-in @app-atom [:aftersalesreceiving :returncaseitem])
     :session-id (get-in @app-atom [:aftersalesreceiving :session-id])}))

(defmethod comms/receive :aftersalesreceiving/returncaseitem-update [app-atom e]
  (toaster/close-toast app-atom)
  (t/transition-prev app-atom)
  (swap! app-atom assoc-in [:aftersalesreceiving :returncaseitems] (:returncaseitems e)))


(defmethod grid/action :aftersalesreceiving/item-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :aftersalesreceiving/item-scan
     :input-key :scan
     :input-type :barcode}))


(defmethod grid/modal-config :aftersalesreceiving/modal-item-unscan [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :aftersalesreceiving/menu-unscan [app-atom config _]
  (grid/open-modal app-atom :aftersalesreceiving/modal-item-unscan
    {:scan ""
     :config
     {:title "Unscan Product"
      :field-text "Barcode"
      :initial-value ""
      :save-text "Capture"
      :save-key :aftersalesreceiving/item-unscan
      :input-key :manual-scan
      :input-type :barcode}}))

(defn item-list-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Unscan Product"
       :action :aftersalesreceiving/menu-unscan
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Manual Barcode"
       :action :aftersalesreceiving/item-menu-barcode}

      {:label "Cancel Session"
       :action :aftersalesreceiving/menu-cancel-session
       :style
       {:full true :large true :negative true
        :icon-left :warning :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :aftersalesreceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc item-slat < rum/reactive [{:keys [barcode product itemtype qty qtyscanned missing-details]} {:keys [on-click]}]
  (let [qtyscanned (or qtyscanned 0)

        slat-color
        (cond
          (= qtyscanned qty) :success
          ;todo use another color
          missing-details :warning
          (pos? qtyscanned) :warning)]

    [:article.slat.product-slat.transfer-product-slat
     {:class (u/bem :slat [slat-color]) :on-click on-click}
     [:div.product-slat__qty.transfer-product-slat__qty
      [:div.transfer-product-slat__count
       [(if (zero? qtyscanned)
          :b.u-text-status-negative
          :b) qtyscanned]
       [:span.u-pipe "of"]
       [:span qty]]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1.product-slat__title
         [:span.product-slat__brand itemtype]
         product]]]
      [:ul.product-slat__details
       [:li.product-slat__barcode
        [:b.u-text-spaced-1 barcode]]]]]))

(rum/defc items < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesreceiving])
        items (cmn/curact current-atom :items)
        location (cmn/curact current-atom :location)
        allow-close? (cmn/curact current-atom :allow-close?)
        allow-next? (empty? (filter #(not= (:qty %) (:qtyscanned %)) items))]

    (screen-wrapper app-atom {:modal-fn item-list-modal} :items
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Progress: " (count (filter (comp pos? :qtyscanned) items)) " / " (count items))
         [:span.u-hidden-from-view " - "]]]
       [:div.slats
        (map
          (fn [i]
            (rum/with-key
              (item-slat i
                {:on-click
                 #(grid/dispatch-action app-atom
                    :aftersalesreceiving/item-modal i)})
              (:barcode i)))
          items)]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "Scan items for location " (:name location)]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (cond
           (not allow-next?)
           nil
           :else
           #(t/transition-next app-atom :aftersalesreceiving/confirm))}))))

(defmethod flow/render-screen :aftersalesreceiving/items [app-atom screen]
  (items app-atom))


(defmethod flow/barcode-dispatch-screen :aftersalesreceiving/items [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersalesreceiving/item-scan {:scan scan}))

(defmethod grid/action :aftersalesreceiving/item-scan [app-atom {:keys [scan manual-qty]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/item-scan
    {:scan (or scan (get-in @app-atom [:aftersalesreceiving :modal-item :barcode]))
     :manual-qty manual-qty
     :unscan? false
     :location-id (get-in @app-atom [:aftersalesreceiving :location :id])
     :session-id (get-in @app-atom [:aftersalesreceiving :session-id])}))


(defmethod comms/receive :aftersalesreceiving/item-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (if (not (:items e))
    (toaster/open-toast app-atom :error "No items found" {})
    (swap! app-atom update :aftersalesreceiving assoc
      :allow-close? (:allow-close? e)
      :items (:items e))))


(defmethod flow/barcode-dispatch-modal :aftersalesreceiving/modal-item-unscan [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :aftersalesreceiving/item-unscan {:modal-scan scan}))

(defmethod grid/action :aftersalesreceiving/item-unscan [app-atom {:keys [modal-scan manual-scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/item-scan
    {:scan (or modal-scan manual-scan)
     :unscan? true
     :location-id (get-in @app-atom [:aftersalesreceiving :location :id])
     :session-id (get-in @app-atom [:aftersalesreceiving :session-id])}))

(defmethod grid/action :aftersalesreceiving/menu-cancel-session [app-atom config _]
  (grid/confirm-modal app-atom
    {:title "Cancel Session"
     :text [:p {:class (u/bem :paragraph [:flush])}
            "Are you sure you want to cancel your session and revert all of your scans?"]
     :confirm-key :aftersalesreceiving/cancel-session
     :confirm-text "Yes" :icon-left :delete :icon-class :3-2 :negative true}))

(defmethod grid/action :aftersalesreceiving/cancel-session [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/cancel-session
    {:session-id (get-in @app-atom [:aftersalesreceiving :session-id])}))

(defmethod comms/receive :aftersalesreceiving/cancel-session [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (do
    (t/transition-next app-atom :aftersalesreceiving/location)
    (swap! app-atom assoc-in [:aftersalesreceiving :session-id] (:session-id e))))


(rum/defc missing-item-slat < rum/reactive
  [{:keys [qty product itemtype qtyscanned barcode]}]
  (let [qty (- qty qtyscanned)]
    [:article.slat.product-slat
     [:div.product-slat__qty [:span qty]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1
         {:class (u/bem :product-slat__title [:small])}
         [:b itemtype]
         (str " " (or product barcode))]]]]]))

(rum/defc confirm < rum/reactive
  [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesreceiving])
        items (cmn/curact current-atom :items)
        itemqty (reduce + 0 (map :qty items))
        packeditemqty (reduce + 0 (map :qtyscanned items))
        remaining-items (filter #(> (:qty %) (:qtyscanned %)) items)
        remaining-itemqty (reduce + 0 (map :qty remaining-items))
        remaining-packeditemqty (reduce + 0 (map :qtyscanned remaining-items))]

    (screen-wrapper app-atom {} :confirm
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Confirm " (when (not (empty? remaining-items)) "Part ") "Fulfillment")]
        [:ul
         {:class (u/bem :order-calc [:fulfillment])}
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:truck :block])}]]
          [:span.order-calc__item-name "Items needed:"]
          [:span.order-calc__item-value [:b itemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :success :block])}]]
          [:span.order-calc__item-name "Items received:"]
          [:span.order-calc__item-value [:b.u-text-status-success packeditemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :error :block])}]]
          [:span.order-calc__item-name "Items not received:"]
          [:span.order-calc__item-value
           [:b.u-text-status-negative (- remaining-itemqty remaining-packeditemqty)]]]]]
       (when (not (empty? remaining-items))
         [:div
          {:class (u/bem :slats [:items-missing])}
          [:h3.slat.heading-slat
           [:span.heading-slat__icon-wrapper
            [:i {:class (u/bem :icon [:error :block])}]]
           [:span.heading-slat__text "Not received:"]]
          (map missing-item-slat remaining-items)])
       [:div.u-margin-bottom-24
        {:class (u/bem :section [:medium])}
        (feedback/action-feedback :truck "Checked" " the item list?" (rum/cursor-in current-atom [:aftersalesreceiving :confirmed]) {})]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Confirm"
         :right-style :call-to-action
         :right-no-icon true
         :right-fn
         (when (cmn/curact current-atom [:aftersalesreceiving :confirmed])
           #(grid/dispatch-action app-atom :aftersalesreceiving/order {}))}))))

(defmethod flow/render-screen :aftersalesreceiving/confirm [app-atom screen]
  (confirm app-atom))

(defmethod grid/action :aftersalesreceiving/confirm [app-atom]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/confirm
    {:delivery-uuid (get-in @app-atom [:aftersalesreceiving :delivery-uuid])
     :session-id (get-in @app-atom [:aftersalesreceiving :session-id])}))

(defmethod comms/receive :aftersalesreceiving/confirm [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :aftersalesreceiving/finished))

(defmethod flow/render-screen :aftersalesreceiving/finished [app-atom screen]
  (receiving/finished app-atom
    steps
    :aftersalesreceiving))